var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuyUsed = function SvgBuyUsed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.43 44.33H56a1 1 0 0 0 .88-.53l14-26.33A1 1 0 0 0 70 16H19.28L18 9.79A1 1 0 0 0 17 9h-7a1 1 0 0 0 0 2h6.19l6.72 32L16 50.24A4 4 0 0 0 18.74 57a8 8 0 1 0 10.53 0h21.46A8 8 0 1 0 56 55H18.91a2 2 0 0 1-1.45-3.38ZM68.34 18 55.4 42.33H24.81L19.7 18ZM62 63a6 6 0 1 1-6-6 6 6 0 0 1 6 6m-32 0a6 6 0 1 1-6-6 6 6 0 0 1 6 6"
  })));
};
export default SvgBuyUsed;